import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { DataNode } from "graphql/types"

import { StyledButton } from "components/Button/StyledButton"
import { TextBlockDiffPreview } from "components/ReportNodeTextBlock/TextBlockDiffPreview"
import { TextBlockInfoCompact } from "components/ReportNodeTextBlock/TextBlockInfoCompact"
import { isNodeImage } from "store/typeGuards"
import ImageManager from "./ImageManager"

type ReportNodeImageDialogProps = {
  open: boolean
  onClose: () => void
  node: DataNode
  // eslint-disable-next-line no-unused-vars
  setNode: (node: DataNode) => void
  onSave: () => void
}

export const ReportNodeImageEditDialog = (props: ReportNodeImageDialogProps) => {
  const { open, onClose, node, setNode, onSave } = props
  return (
    <Dialog maxWidth="lg" fullWidth open={open}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Bilder bearbeiten
        <TextBlockInfoCompact dataNode={node} />
      </DialogTitle>
      <DialogContent>
        {node && isNodeImage(node) && <ImageManager node={node} setNode={setNode} />}
        <TextBlockDiffPreview dataNode={node} />
      </DialogContent>
      <DialogActions>
        <StyledButton buttonType="cancel" onClick={onClose} />
        <StyledButton buttonType="save" onClick={onSave} />
      </DialogActions>
    </Dialog>
  )
}
